import { Link } from "react-router-dom";
import { Globe, Home as HomeIcon } from "lucide-react";

export const Footer = () => (
  <footer className="mt-20 border-t border-border bg-muted/40">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-12 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
      <div>
        <p className="font-display text-sm">Support</p>
        <div className="mt-4 flex flex-col gap-3 text-[13px] text-muted-foreground">
          <span>Help centre</span>
          <span>Safety information</span>
          <span>Report a listing</span>
          <Link to="/privacy" className="hover:text-foreground transition-colors duration-200" data-testid="footer-privacy-link">Privacy policy</Link>
          <Link to="/terms" className="hover:text-foreground transition-colors duration-200" data-testid="footer-terms-link">Terms &amp; conditions</Link>
        </div>
      </div>
      <div>
        <p className="font-display text-sm">Discover</p>
        <div className="mt-4 flex flex-col gap-3 text-[13px] text-muted-foreground">
          <Link to="/delhi-ncr/flats-for-rent" className="hover:text-foreground transition-colors duration-200">Flats for rent in Delhi NCR</Link>
          <Link to="/mumbai/flats-for-sale" className="hover:text-foreground transition-colors duration-200">Flats for sale in Mumbai</Link>
          <Link to="/pune/pg-for-rent" className="hover:text-foreground transition-colors duration-200">PG in Pune</Link>
          <Link to="/bengaluru/flats-for-rent" className="hover:text-foreground transition-colors duration-200">Flats for rent in Bengaluru</Link>
          <Link to="/properties?category=plot" className="hover:text-foreground transition-colors duration-200">Plots &amp; land</Link>
        </div>
      </div>
      <div>
        <p className="font-display text-sm">Hosting</p>
        <div className="mt-4 flex flex-col gap-3 text-[13px] text-muted-foreground">
          <Link to="/post-property" className="hover:text-foreground transition-colors duration-200">List your property</Link>
          <Link to="/dashboard" className="hover:text-foreground transition-colors duration-200">My listings</Link>
          <Link to="/dashboard" className="hover:text-foreground transition-colors duration-200">My enquiries</Link>
        </div>
      </div>
      <div>
        <p className="font-display text-sm">Contact</p>
        <div className="mt-4 flex flex-col gap-3 text-[13px] text-muted-foreground">
          <span>+91 98000 00000</span>
          <span>support@houses7.com</span>
          <span>Mon – Sat, 9am to 7pm IST</span>
        </div>
      </div>
    </div>
    <div className="border-t border-border">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-6 flex flex-wrap items-center gap-4 justify-between text-[13px] text-muted-foreground">
        <span className="flex items-center gap-2">
          <HomeIcon className="h-4 w-4 text-primary" /> © {new Date().getFullYear()} Houses7.com
        </span>
        <span className="flex items-center gap-4">
          <Link to="/privacy" className="hover:text-foreground transition-colors duration-200">Privacy</Link>
          <Link to="/terms" className="hover:text-foreground transition-colors duration-200">Terms</Link>
        </span>
        <span className="flex items-center gap-2">
          <Globe className="h-4 w-4" /> English (IN) · ₹ INR
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
